module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-square-36b84a20.svg";